/**
 * The width every screen in the portal is laid out inside.
 *
 * One value, in one place, because the menu bar has to line up with the page
 * under it. Each screen used to choose its own — the quote list was 5xl, its
 * options 6xl, the estimator 7xl, the dashboard the whole window — so the bar
 * could only ever agree with one of them, and moving between screens shifted
 * the content sideways under a bar that stayed put.
 *
 * 7xl because the estimator sets the floor: the drawing and its panels sit
 * side by side and need the room. Everything else is roomier than it was
 * rather than narrower.
 *
 * A screen whose content reads better in a narrow column — an announcement to
 * read, a "page not found" — still centres that column inside this frame
 * instead of widening to fill it. The frame is what lines up; the column is a
 * choice about reading.
 */
export const PAGE_WIDTH = 'mx-auto w-full max-w-7xl';
